/**
 * @module ol/render/ReplayType
 */

/**
 * @enum {string}
 */
export default {
  CIRCLE: 'Circle',
  DEFAULT: 'Default',
  IMAGE: 'Image',
  LINE_STRING: 'LineString',
  POLYGON: 'Polygon',
  TEXT: 'Text'
};

//# sourceMappingURL=ReplayType.js.map


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/ol/render/ReplayType.js
// module id = ../../../../ol/render/ReplayType.js
// module chunks = 3